import axios from 'axios';
import Cookies from 'js-cookie';

export const getSessionId = async () => {
  let sessionId = Cookies.get('sessionId');
  
  if (!sessionId) {
    try {
      const response = await axios.get(process.env.VUE_APP_API_URL + '/client/session/generate');
      sessionId = response.data.data; // 서버에서 발급받은 sessionId
      Cookies.set('sessionId', sessionId, { expires: 7 }); // 7일 동안 유지
    } catch (error) {
      console.error("세션 ID 발급 오류:", error);
    }
  }

  return sessionId;
  
};
